import { Component, AfterViewInit, DoCheck, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { GridOptions, BalancedColumnTreeBuilder, ICellRendererComp } from 'ag-grid';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as encoding from 'encoding-japanese';

import { ExpenseService } from '../../../service/expense/expense.service';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { isNumber } from '../../../util/util';
import { AgGridHelper } from 'app/util/AgGridHelper';
import { GridSelectRendererComponent } from '../../../render/grid-select-renderer.component';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa8014',
  templateUrl: 'wa8014.component.html',
  styleUrls: ['wa8014.component.scss']
})
export class Wa8014Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA8014:諸掛一括修正';

  public salesgroupownerObj = {};
  public notinvoiceObj: any = {};
  public ownerId: number;
  public gridOptions: GridOptions;
  public rowData: any[];

  public validation = validation;
  
  public working = false;
  public height = 500;
  public gridHeight = 450;
  public production = environment.production;
  public backgroundColor: string;
  public gridEditFl = [];
  private errorInfo = '';
  private openotherwindow: boolean = false;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  @ViewChild('gridView')
  gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private searchKeyKubun: any[];
  private paginationGetRowCount = 0;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private isSubmitButtonEnabled = false;
  private gridSelectDataSource = [];
  private EXPENSE_RANDOM_PROP_NAME = '__index';
  private exPenseData = null

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private expenseService: ExpenseService,
    private salesGroupOwnerService: SalesGroupOwnerService,
    private commonService: CommonService
  ) {
    const rows = localStorage.getItem('wa8014_rowsPerPage_idx');
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: 500,
      singleClickEdit: true,
      suppressRowClickSelection: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa8014_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onCellValueChanged: (params) => {
        this.isSubmitButtonEnabled = true;
      }
    };


    this.createGridColumns();

    this.gridHelper.setGridOptions(this.gridOptions);

    this.height = window.innerHeight - 80;
    this.setGridHeight();
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.searchKeyKubun = [];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridHelper.onViewportScrollListener = () => {
      this.fixedDateFilterInput();
    };
  }

  createGridColumns() {
    let notinvoiceObj = [
      { name: '', value: 0 },
      { name: '請求対象外', value: 1 }];
    this.gridOptions.columnDefs = [
      {
        headerName: '発生日',
        headerTooltip: '発生日',
        field: 'originalDt',
        width: this.getColumnWidth('originalDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '項目',
        field: 'salesgroupId',
        width: this.getColumnWidth('salesgroupTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellEditor: 'select',
        cellClass: (params) => {
          return ['tr', 'cellclass'];
        },
        cellRendererFramework: GridSelectRendererComponent,
        cellRendererParams: {
          dataSource: this.gridSelectDataSource,
          field: 'salesgroupId',
          // defaultValue : '',
          selectClass: 'largeWidth',
          onSelectChanged: this.onGridSelectChanged.bind(this),
          cellClass: this.gridCellClass.bind(this)
        }
      },
      {
        headerName: '数量',
        field: 'pcsNr',
        width: this.getColumnWidth('pcsNr', 100),
        editable: true,
        cellEditor: 'numericCellEditor',
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = true;
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'pcsNr');
        },
      },
      {
        headerName: '単価',
        field: 'unitpricedispNr',
        width: this.getColumnWidth('unitpricedispNr', 100),
        editable: true,
        cellEditor: 'numericCellEditor',
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = true;
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'unitpricedispNr');
        },
      },
      {
        headerName: '金額',
        headerTooltip: '金額',
        field: 'pricedispNr',
        width: this.getColumnWidth('pricedispNr', 100),
        valueGetter: params => {
          if (this.gridEditFl[params.node.childIndex] == true) {
            var tmpPricedispNr = params.data.unitpricedispNr * params.data.pcsNr;
            return Math.round(Math.abs(tmpPricedispNr)) * ((tmpPricedispNr < 0) ? -1 : 1 );
          } else {
            return params.data.pricedispNr;
          }
        },
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = false;
        },
        unSortIcon: true,
        suppressMenu: true,
        editable: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'pricedispNr');
        },
      },
      {
        headerName: '備考',
        headerTooltip: '備考',
        field: 'expensememoTx',
        width: this.getColumnWidth('expensememoTx', 280),
        editable: true,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'expensememoTx');
        }
      },
      {
        headerName: '請求対象外',
        headerTooltip: '請求対象外',
        field: 'notinvoiceFl',
        width: this.getColumnWidth('notinvoiceTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellEditor: 'select',
        cellClass: (params) => {
          return ['tr', 'cellclass'];
        },
        cellRendererFramework: GridSelectRendererComponent,
        cellRendererParams: {
          dataSource: notinvoiceObj,
          field: 'notinvoiceFl',
          onSelectChanged: this.onGridSelectChanged1.bind(this),
          cellClass: this.gridCellsClass.bind(this)
        }
      }
    ];
  }

  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa8014_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa8014_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa8014_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  setGridHeight() {
    this.gridHeight = window.innerHeight - 170;
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
  }

  onSubmit() {

    this.working = true;
    this.expenseService
      .get(this.ownerId)
      .then(outputJson => {
        this.working = false;
        var i = outputJson.expenses.length;
        while (i--) {
          if (outputJson.expenses[i].commitFl == 1) {
            outputJson.expenses.splice(i, 1);
          }
        }

        if (outputJson.expenses != null && outputJson.expenses.length > 0) {
          var e = 0;
          outputJson.expenses.forEach(v => {
            v[this.EXPENSE_RANDOM_PROP_NAME] = e;
            e++;
          });
        }
        this.rowData = outputJson.expenses;

        this.exPenseData = [];
        outputJson.expenses.forEach(item => {
          var tmp = {};
          for (var k in item)
            tmp[k] = item[k]
          this.exPenseData.push(tmp);
        });
        console.log(this.exPenseData)

        if (this.rowData.length == 0) {
          this.errorInfo = '未確定のデータがありません';
          this.router.navigate(['wa8010']);
          sessionStorage.removeItem('wa8014_ownerId');
          return;
        }
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  execute() {
    console.log(this.rowData)

    // if (!this.isSubmitButtonEnabled)
    //   return;
    this.working = true;
    for (let i = 0; i < this.rowData.length; i++) {
      let rowNum = i + 1;
      if (!this.rowData[i].pcsNr) {
        this.working = false;
        this.errorInfo = rowNum + '行目：数量は必須です';
        return;
      }
      //SW-1551　チェック範囲修正（-999999.999～999999.999）
      //SWMS-1183 バリデーション修正
      if (!isNumber(this.rowData[i].pcsNr) || this.rowData[i].pcsNr > validation.pcsNr.maxNr || this.rowData[i].pcsNr < validation.pcsNr.minNr) {
        this.working = false;
        this.errorInfo = rowNum + '行目：数量は' + validation.pcsNr.minNr.toString() + '~' + validation.pcsNr.maxNr.toString() + 'の半角数字で入力してください';
        return;
      }
      //SW-1872
      if (Number(this.rowData[i].pcsNr) === 0) {
        this.working = false;
        this.errorInfo = rowNum + '行目：数量は' + validation.message.exclude0;
        return;
      }
      if (!this.rowData[i].unitpricedispNr && this.rowData[i].unitpricedispNr != 0) {
        this.working = false;
        this.errorInfo = rowNum + '行目：単価は必須です';
        return;
      }
      //SW-1551　チェック範囲修正（-9999999.99～9999999.99）
      //SWMS-1183 バリデーション修正
      if (!isNumber(this.rowData[i].unitpricedispNr) || this.rowData[i].unitpricedispNr > 99999999.99 || this.rowData[i].unitpricedispNr < -99999999.99 ) {
        this.working = false;
        this.errorInfo = rowNum + '行目：単価は-99999999.99~99999999.99の半角数字で入力してください';
        return;
      }
      //SW-1551　金額チェック追加
      //SWMS-1183 バリデーション修正
      //金額上限
      if ((this.rowData[i].unitpricedispNr * this.rowData[i].pcsNr) > validation.pricedispNr.maxNr) {
        this.working = false;
        this.errorInfo = rowNum + '行目：' + validation.message.priceOver + validation.pricedispNr.maxNr.toString();
        return;
      }
      //金額下限
      if ((this.rowData[i].unitpricedispNr * this.rowData[i].pcsNr) < validation.pricedispNr.minNr) {
        this.working = false;
        this.errorInfo = rowNum + '行目：金額が下限を超えています。下限額：' + validation.pricedispNr.minNr.toString();
        return;
      }
      if (this.rowData[i].expensememoTx && this.rowData[i].expensememoTx.length > 50) {
        this.working = false;
        this.errorInfo = rowNum + '行目：備考は50文字以下で入力してください';
        return;
      }
    }

    if (this.working) {
      for (let i = 0; i < this.rowData.length; i++) {
        var tmpPricedispNr = this.rowData[i].unitpricedispNr * this.rowData[i].pcsNr;
        this.expenseService
          .put(
            this.rowData[i].expenseId,
            this.rowData[i].bookDt,
            +this.rowData[i].salesgroupId,
            this.rowData[i].unitpricedispNr,
            this.rowData[i].pcsNr,
            tmpPricedispNr,
            this.rowData[i].typetaxCd,
            0,
            this.rowData[i].notinvoiceFl,
            0,
            this.rowData[i].expensememoTx,
            'wa8014'
          )
          .then(outputJson => {
            if (i == this.rowData.length - 1) {
              this.working = false;
              // this.router.navigate(['wa8010']);
              sessionStorage.removeItem('wa8010_ownerId');
              this.closeButtonClick.emit(true);
            }
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      }
    }
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    if (this.rowData == null || this.rowData.length == 0)
      return;
    this.isSubmitButtonEnabled = false;

    var upd = true;

    for (let i = 0; i < this.rowData.length; i++) {
      let rowNum = this.rowData.length - i;
      var exPense = this.exPenseData[i];
      if (exPense.salesgroupId != this.rowData[i].salesgroupId) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (exPense.pcsNr != this.rowData[i].pcsNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (exPense.unitpricedispNr != this.rowData[i].unitpricedispNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (exPense.pricedispNr != this.rowData[i].pricedispNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (exPense.expensememoTx !== this.rowData[i].expensememoTx) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (exPense.notinvoiceFl != this.rowData[i].notinvoiceFl) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

    }

    if (this.isSubmitButtonEnabled != upd)
      this.errorInfo = '';

    this.isSubmitButtonEnabled = upd;

  }

  gridCellClass(node, selectedValue) {
    if (this.exPenseData != null) {
      var exPense = this.exPenseData[node.rowIndex];
      if (selectedValue != exPense.salesgroupId) {
        return ['tr', 'cellclass', 'active', 'largeWidth'];
      }
    }
    return ['tr', 'cellclass', 'largeWidth'];
  }

  gridCellsClass(node, selectedValue) {
    if (this.exPenseData != null) {
      var exPense = this.exPenseData[node.rowIndex];
      if (selectedValue != exPense.notinvoiceFl) {
        return ['tr', 'cellclass', 'active'];
      }
    }
    return ['tr', 'cellclass'];
  }

  inputCellClass(params, field) {
    if (this.exPenseData != null) {
      for (let i = 0; i < this.exPenseData.length; i++) {
        if (this.exPenseData[i][this.EXPENSE_RANDOM_PROP_NAME] == params.data[this.EXPENSE_RANDOM_PROP_NAME]) {
          var cls = null;
          if (params.value != this.exPenseData[i][field]) {
            cls = 'txtactive';
          }
          return this._inputCellClass(params, cls);
        }
      }
    }
    return this._inputCellClass(params, null);
  }
  _inputCellClass(params, cls) {
    var defaultClss = ['tr', 'cellclass', 'editClass', 'noCellFocus'];
    if (cls == null) {
      var rowDOM = this.gridView.nativeElement.querySelectorAll('div[role="row"]');

      if (rowDOM != null) {
        rowDOM.forEach(item => {

          if (!item.hasAttribute('row'))
            return;
          var rowValue = item.getAttribute('row');
          if (rowValue !== params.node.id)
            return;

          var cells = item.querySelectorAll('.ag-cell[role="gridcell"][colId="' + params.colDef.field + '"]');//
          if (cells.length == 0)
            return;

          if (cells[0].classList.contains('txtactive'))
            cells[0].classList.remove('txtactive');
        });
      }
      return defaultClss;
    }
    defaultClss.push(cls);
    return defaultClss;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.initDatas();
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    sessionStorage.removeItem('rowData');
    this.closeButtonClick.emit(false);
    this.errorInfo = '';
  }

  onGridSelectChanged(node, selectedValue) {
    this.rowData[node.id].salesgroupId = selectedValue;
  }

  onGridSelectChanged1(node, selectedValue) {
    this.rowData[node.id].notinvoiceFl = selectedValue;
  }

  initDatas() {
    this.isSubmitButtonEnabled = false;
    if (sessionStorage.getItem('salesgroupownerObj')) {
      this.salesgroupownerObj = JSON.parse(sessionStorage.getItem('salesgroupownerObj'));
    } else {
      this.salesgroupownerObj = [];
    }

    this.gridSelectDataSource = [];
    // this.gridSelectDataSource.push({
    //    name: '',
    //    value: ''
    // });

    for (let salesgroupownerKey in this.salesgroupownerObj) {
      this.gridSelectDataSource.push({
        name: this.salesgroupownerObj[salesgroupownerKey],
        value: salesgroupownerKey
      });
    }
    this.renderDropSelectComponent();

    this.ownerId = Number(sessionStorage.getItem('wa8014_ownerId'));
    this.onSubmit();
  }

  renderDropSelectComponent() {
    this.gridOptions.columnApi.getColumn('salesgroupId').getColDef().cellRendererParams.dataSource = this.gridSelectDataSource;
    this.gridOptions.api.refreshCells({
      columns: ['salesgroupId'],
      force: true
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8014/wa8014.component.ts